module.exports = __webpack_public_path__ + "img/img-homepage-p-btt.335c2347.svg";